import { lazy, Suspense, useEffect, useMemo, useState } from "react";
import {
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable,
} from "material-react-table";
import { Box, Button, IconButton, TextField, Tooltip } from "@mui/material";
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { type User, fakeData, usStates } from "./makeData";
import { citiesList, usStateList } from "./makeData";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Accordion from "react-bootstrap/Accordion";
import Table from "react-bootstrap/Table";
import { Col, Container, Form, Row } from "reactstrap";
import axiosInstance from "../../../Utils/axiosInstance";
import { backendbaseUrl } from "../../../Utils/baseUrl";
import { toast } from "react-toastify";
import axios from "axios";
import { showDeleteConfirmModal } from "../../../Components/ConfirmModal";
import { StyledTableFirstSecond } from "../../Book/TableBook";
type BookTYpe = {
  id: string;
  name: string;
};
const Example = () => {
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const [bookText, setBookText] = useState<string>(""); // For text input
  const [bookData, setBookData] = useState<User[]>([]);
  const columns = useMemo<MRT_ColumnDef<User>[]>(
    () => [
      // {
      //   accessorKey: "id",
      //   header: "Id",
      //   enableEditing: false,
      //   enableSorting: false, 
      //   Cell: ({ row }) => row.index + 1, 
       
      // },
      {
        accessorKey: "date",
        header: "Date",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.date,
          helperText: validationErrors?.date,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              date: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "transactTime",
        header: "Transact Time",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.transactTime,
          helperText: validationErrors?.transactTime,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              transactTime: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "tradeID",
        header: "Trade ID",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.tradeID,
          helperText: validationErrors?.tradeID,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              tradeID: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "legRefID",
        header: "LegRef ID",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.legRefID,
          helperText: validationErrors?.legRefID,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              legRefID: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "trader",
        header: "Trader",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.trader,
          helperText: validationErrors?.trader,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              trader: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "clearer",
        header: "Clearer",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.clearer,
          helperText: validationErrors?.clearer,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              clearer: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "clearingAccount",
        header: "Clearing Account",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.clearingAccount,
          helperText: validationErrors?.clearingAccount,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              clearingAccount: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "derivative",
        header: "Derivative",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.derivative,
          helperText: validationErrors?.derivative,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              derivative: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "tradeType",
        header: "Trade Type",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.tradeType,
          helperText: validationErrors?.tradeType,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              tradeType: undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "parentCompany",
        header: "Parent Company",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.parentCompany,
          helperText: validationErrors?.parentCompany,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              parentCompany  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "book",
        header: "Book",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.book,
          helperText: validationErrors?.book,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              book  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "strategy",
        header: "Strategy",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.strategy,
          helperText: validationErrors?.strategy,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              strategy  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "symbolCode",
        header: "Symbol Code",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.symbolCode,
          helperText: validationErrors?.symbolCode,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              symbolCode  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "marketID",
        header: "Market ID",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.marketID,
          helperText: validationErrors?.marketID,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              marketID  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "contractName",
        header: "Contract Name",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.contractName,
          helperText: validationErrors?.contractName,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              contractName  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "volume",
        header: "Volume",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.volume,
          helperText: validationErrors?.volume,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              volume  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "unit",
        header: "Unit",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.unit,
          helperText: validationErrors?.unit,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              unit  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "startDate",
        header: "Start Date",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.startDate,
          helperText: validationErrors?.startDate,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              startDate  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "endDate",
        header: "End Date",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.endDate,
          helperText: validationErrors?.endDate,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              endDate  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "price",
        header: "Price",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.price,
          helperText: validationErrors?.price,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              price  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "tick",
        header: "Tick",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.tick,
          helperText: validationErrors?.tick,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              tick  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "holiday",
        header: "Holiday",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.holiday,
          helperText: validationErrors?.holiday,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              holiday  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "type",
        header: "Type",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.type,
          helperText: validationErrors?.type,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              type  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "EFSCode",
        header: "EFS Code",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.EFSCode,
          helperText: validationErrors?.EFSCode,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              EFSCode  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "broker",
        header: "Broker",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.broker,
          helperText: validationErrors?.broker,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              broker  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "orderID",
        header: "Order ID",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.orderID,
          helperText: validationErrors?.orderID,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              orderID  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "clientOrdID",
        header: "Client Ord ID",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.clientOrdID,
          helperText: validationErrors?.clientOrdID,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              clientOrdID  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "tradeReportID",
        header: "Trade Report ID",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.tradeReportID,
          helperText: validationErrors?.tradeReportID,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              tradeReportID  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "notes",
        header: "Notes",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.notes,
          helperText: validationErrors?.notes,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              notes  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "lastEditedDate",
        header: "Last Edited Date",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.lastEditedDate,
          helperText: validationErrors?.lastEditedDate,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              lastEditedDate  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      {
        accessorKey: "lastEditPerson",
        header: "Last Edit Person",
        //  size: "auto",
        // minSize: 100,
        // maxSize: 200,
        muiEditTextFieldProps: {
          required: true,
          error: !!validationErrors?.lastEditPerson,
          helperText: validationErrors?.lastEditPerson,
          //remove any previous validation errors when user focuses on the input
          onFocus: () =>
            setValidationErrors({
              ...validationErrors,
              lastEditPerson  : undefined,
            }),
          //optionally add validation checking for onBlur or onChange
        },
      },
      
    ],
    [validationErrors]
  );

  //call CREATE hook
  const { mutateAsync: createUser, isPending: isCreatingUser } =
    useCreateUser();
  //call READ hook
  const {
    data: fetchedUsers = [],
    isError: isLoadingUsersError,
    isFetching: isFetchingUsers,
    isLoading: isLoadingUsers,
  } = useGetUsers();
  //call UPDATE hook

  const submitBook = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // This should prevent the default form submission
    console.log("click added");
    
    if (!bookText.trim()) {
      console.log("Empty book name, not submitting");
      return; // Prevent empty submission
    }
  
    try {
      const payload = { name: bookText.trim() };
      console.log("Sending payload:", payload);
      
      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/books/`,
        payload
      );
      
      console.log("API Response:", response.data);
      
      if (response.status === 201) {
        // Successfully created book
        toast.success("Book added successfully!");
        setBookText(""); // Clear input field
        
        // Fetch updated data to ensure the latest state
        await bookFetchData();
      } else {
        console.error("Failed to add book:", response);
        toast.error("Failed to add book");
      }
    } catch (error) {
      console.error("Error adding book:", error);
      toast.error("Error adding book");
    }
  };
  const bookFetchData = async () => {
    try {
      console.log("Fetching books data...");
      const response = await axiosInstance.get(
        `${backendbaseUrl}/paper-app/books/`
      );
      
      console.log("Fetch response status:", response.status);
      console.log("Fetched data:", response.data);
      
      if (response.status === 200) {
        // Ensure successful fetch
        const data = response.data.map((book: BookTYpe) => ({
          id: book.id,
          bookName: book.name,
        }));
  
        console.log("Processed data:", data);
        setBookData(data); // Ensure state updates with the latest list
      } else {
        console.error("Failed to fetch books:", response);
        toast.error("Failed to fetch books list");
      }
    } catch (error) {
      console.error("Error fetching books:", error);
      toast.error("Error loading books data");
    }
  };

  useEffect(() => {
    bookFetchData();
  }, []);
  const { mutateAsync: updateUser, isPending: isUpdatingUser } =
    useUpdateUser();
  //call DELETE hook
  const { mutateAsync: deleteUser, isPending: isDeletingUser } =
    useDeleteUser();

  //CREATE action
  const handleCreateUser: MRT_TableOptions<User>["onCreatingRowSave"] = async ({
    values,
    table,
  }) => {
    const newValidationErrors = validateUser(values);
    if (Object.values(newValidationErrors).some((error) => error)) {
      setValidationErrors(newValidationErrors);
      return;
    }
    setValidationErrors({});
  };

   //UPDATE action
   const handleSaveUser: MRT_TableOptions<User>["onEditingRowSave"] = async ({
    values,
    row,
    table,
  }) => {
    try {
      const id = row.original.id;

      if (!id) {
        console.error("User ID is missing, cannot update.");
        return;
      }
      console.log("Submitting values for update:", values);
      console.log(values);
      // Ensure required fields exist before making request
      // if (!values.id) {
      //   console.error("User ID is missing, cannot update.");
      //   return;
      // }

      if (!values.bookName) {
        console.error("Name field is required but missing.");
        return;
      }

      const newValidationErrors = validateUser(values);
      if (Object.values(newValidationErrors).some((error) => error)) {
        setValidationErrors(newValidationErrors);
        return;
      }

      setValidationErrors({});

      // Send PUT request to update the user
      const response = await axiosInstance.put(
        `${backendbaseUrl}/paper-app/books/${id}/`,
        {
          name: values.bookName,
        }
      );

      console.log("API Response:", response);

      if (response.status === 200 || response.status === 201) {
        toast.success(`Updated successfully`);
        await updateUser(values); // Update local state
        table.setEditingRow(null); // Exit editing mode
        table.resetRowSelection(); // Reset selection
      } else {
        console.error("Failed to update user:", response.data);
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error updating user:",
          error.response?.data || error.message
        );
      } else {
        console.error("Unexpected error:", (error as Error).message);
      }
    }
  };

//DELETE action
const openDeleteConfirmModal = async (row: MRT_Row<User>) => {
  const bookId = row.original.id; // Ensure ID exists
  if (!bookId) {
    toast.error("Invalid ID! Cannot delete.");
    return;
  }

  showDeleteConfirmModal({
    title: "Delete Record",
    content: `Are you sure you want to delete this user?`,
    onOk: async () => {
      console.log("Deleting user with ID:", bookId);
      console.log("API URL:", `${backendbaseUrl}/paper-app/books/${bookId}/`);

      try {
        const response = await axiosInstance.delete(
          `${backendbaseUrl}/paper-app/books/${bookId}/`
        );

        console.log("Delete Response:", response);

        if (response.status === 204 || response.status === 200) {
          toast.success("User deleted successfully!");
          // await brokerFetchData(); // Refresh table
          setBookData((prevData) => prevData.filter((book) => book.id !== bookId));
        } else {
          toast.error("Failed to delete the user.");
        }
      } catch (error: any) {
        console.error("Error deleting user:", error);

        if (error.response) {
          console.log("Error Response Data:", error.response.data);
          console.log("Error Status:", error.response.status);
        }

        toast.error(error.response?.data?.message || "An error occurred while deleting.");
      }
    },
  });
};


  const table = useMaterialReactTable({
    columns,

    // enableColumnResizing:true,
    enableColumnPinning: true,
    data: fakeData,
    enableDensityToggle: false,
    createDisplayMode: "row", // ('modal', and 'custom' are also available)
    editDisplayMode: "row", // ('modal', 'cell', 'table', and 'custom' are also available)
    enableEditing: true,
    enableColumnOrdering: true, // ✅ Enables column drag-and-drop
    enableRowOrdering: false, // ✅ Enables row drag-and-drop
    getRowId: (row) => row.id,
    enableColumnFilterModes: true, //enable changing filter mode for all columns unless explicitly disabled in a column def
    initialState: { showColumnFilters: true }, //show filters by default
    enableRowSelection: true,
    filterFns: {
      customFilterFn: (row, id, filterValue) => {
        return row.getValue(id) === filterValue;
      },
    },
    // muiTableProps: {
    //   sx: {
    //     border: '1px solid rgba(81, 81, 81, .5)',
    //     caption: {
    //       captionSide: 'top',
    //     },
    //   },
    // },
    muiTableHeadCellProps: {
      sx: {
        border: "1px solid #e0e0e087",
        fontStyle: "italic",
        fontWeight: "normal",
      },
    },
    muiTableBodyCellProps: {
      sx: {
        border: "1px solid #ebe9e98f",
      },
    },
    muiTablePaperProps: {
      elevation: 0,
      sx: {
        borderRadius: "0",
        border: "0",
      },
    },
    localization: {
      filterCustomFilterFn: "Custom Filter Fn",
    } as any,

    muiToolbarAlertBannerProps: isLoadingUsersError
      ? {
          color: "error",
          children: "Error loading data",
        }
      : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },

    onCreatingRowCancel: () => setValidationErrors({}),
    onCreatingRowSave: handleCreateUser,
    onEditingRowCancel: () => setValidationErrors({}),
    onEditingRowSave: handleSaveUser,

    renderRowActions: ({ row, table }) => (
      <Box sx={{ display: "flex", gap: "1rem" }}>
        <Tooltip title="Edit" className="editIcon">
          <IconButton onClick={() => table.setEditingRow(row)}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete" className="deleteIcon">
          <IconButton color="error" onClick={() => openDeleteConfirmModal(row)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    ),

    state: {
      isLoading: isLoadingUsers,
      isSaving: isCreatingUser || isUpdatingUser || isDeletingUser,
      showAlertBanner: isLoadingUsersError,
      showProgressBars: isFetchingUsers,
      showColumnFilters: true,
    },
  });

  return (
    <div className="page-body">
      <Container fluid>
        <Row>
          <div>
            <div className="table-ad">
              
              <div className="table-ad__wrapper">
                <StyledTableFirstSecond>

                <MaterialReactTable table={table} />
                </StyledTableFirstSecond>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </div>
  );
};

//CREATE hook (post new user to api)
function useCreateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(
        ["users"],
        (prevUsers: any) =>
          [
            ...prevUsers,
            {
              ...newUserInfo,
              id: (Math.random() + 1).toString(36).substring(7),
            },
          ] as User[]
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//READ hook (get users from api)
function useGetUsers() {
  return useQuery<User[]>({
    queryKey: ["users"],
    queryFn: async () => {
      //send api request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve(fakeData);
    },
    refetchOnWindowFocus: false,
  });
}

//UPDATE hook (put user in api)
function useUpdateUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (user: User) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (newUserInfo: User) => {
      queryClient.setQueryData(["users"], (prevUsers: any) =>
        prevUsers?.map((prevUser: User) =>
          prevUser.id === newUserInfo.id ? newUserInfo : prevUser
        )
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//DELETE hook (delete user in api)
function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (userId: string) => {
      //send api update request here
      await new Promise((resolve) => setTimeout(resolve, 1000)); //fake api call
      return Promise.resolve();
    },
    //client side optimistic update
    onMutate: (userId: string) => {
      queryClient.setQueryData(["users"], (prevUsers: any) =>
        prevUsers?.filter((user: User) => user.id !== userId)
      );
    },
    // onSettled: () => queryClient.invalidateQueries({ queryKey: ['users'] }), //refetch users after mutation, disabled for demo
  });
}

//react query setup in App.tsx
const ReactQueryDevtoolsProduction = lazy(() =>
  import("@tanstack/react-query-devtools/build/modern/production.js").then(
    (d) => ({
      default: d.ReactQueryDevtools,
    })
  )
);

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Example />
      {/* <Suspense fallback={null}>
        <ReactQueryDevtoolsProduction />
      </Suspense> */}
    </QueryClientProvider>
  );
}

const validateRequired = (value: string) => !!value.length;
const validateEmail = (email: string) =>
  !!email.length &&
  email
    .toLowerCase()
    .match(
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );

function validateUser(user: User) {
  return {
    // bookName: !validateRequired(user.bookName) ? "First Name is Required" : "",
    // bookName: !validateRequired(user.bookName) ? "Last Name is Required" : "",
    // email: !validateEmail(user.email) ? "Incorrect Email Format" : "",
  };
}
